import React from 'react';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useSelector, useDispatch } from 'react-redux';
import Image from 'next/image';

import { Arrow } from '@/icons/index';
import { useWindowSize } from '@/hooks/index';
import { selectors, actions } from '@/domains/number-sale';
import { Loader, Button } from '@/components/ui';

import YourNumberListItem from './YourNumberListItem';

import styles from './YourNumberList.module.scss';

const YourNumberList = ({
  list,
  loadMore,
  isLoading,
  totalPage,
  detail,
  tabs,
  isEsim,
}) => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector(selectors.selectNumberSale);
  const { t } = useTranslation();
  const [windowsX] = useWindowSize();
  const router = useRouter();

  const limit = windowsX > 600 ? 10 : 6;

  const handleListItemClick = (item) => {
    if (isEsim) {
      router.push({
        pathname: '/esim/checkout',
        query: {
          id: item?.id,
          msisdn: item?.msisdn,
        },
      });
    } else {
      router.push(
        `/number-sale/checkout/${item?.msisdn}/${item?.levelName}/${item?.prefix}/${item?.price}`,
      );
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'ordernumber',
    });
  };

  const renderList = (item, index) => {
    if (!item) return;
    return (
      <YourNumberListItem
        key={index}
        titles
        detail={detail}
        data={item}
        isEsim={isEsim}
        onClick={() => handleListItemClick(item)}
        itemScope
        itemType='http://schema.org/ItemList'
      />
    );
  };

  const tabHandler = (i) => {
    dispatch(actions.setActiveTab(i));
  };

  return (
    <>
      <div
        className={styles.container}
        itemScope
        itemType='http://schema.org/Offer'
      >
        {tabs && (
          <div className={styles.tabs}>
            {tabs?.map((tab) => {
              return (
                <Button
                  key={tab?.value}
                  variant={
                    tab?.value === activeTab?.value ? 'normal' : 'transparent'
                  }
                  onClick={() => tabHandler(tab)}
                  data-testid={`number-level-${tab.value}`}
                >
                  {tab?.name === 'All' ? t('common:All') : tab?.name}
                </Button>
              );
            })}
          </div>
        )}
        {totalPage < 1 && !isEsim && !isLoading && (
          <div className={styles.notFound}>
            <Image
              src='/assets/notFound.png'
              width={180}
              height={180}
              alt='Not found image'
            />
            <span>{t('esim:common.numberNotFound')}</span>
          </div>
        )}
        {isLoading && !isEsim && <Loader />}
        {list?.map(renderList)}

        <div className={styles.loadMoreContainer}>
          {isLoading === 'pending'
            ? t('common:loading')
            : list?.length >= limit && (
                <button
                  className={styles.loadMore}
                  onClick={loadMore}
                  aria-label='detail?.show_more_button_text'
                >
                  <span>
                    {detail?.show_more_button_text ?? t('numbersale:loadMore')}
                    <Arrow width={18} />
                  </span>
                </button>
              )}
        </div>
      </div>
    </>
  );
};

export default YourNumberList;
